export default __webpack_public_path__ + "static/media/alIconLight.b1003b86.svg";